module.exports = __webpack_public_path__ + "Flag-417.dc0bbee16376629ed7044496d61f5392.svg";